var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICN_-_PARTNER",
    "data-name": "ICN - PARTNER",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M3,0H29a3,3,0,0,1,3,3V29a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    fill: "#cccbcb",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handshake",
    transform: "translate(5.657 5.657)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    width: 28,
    height: 28,
    transform: "translate(-3.657 -3.657)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M15.309,66.219a.851.851,0,0,1-1.033.62l-3.21-.8a1.714,1.714,0,0,1-.7-.367l-2.4-2.088A.852.852,0,1,1,9.078,62.3l2.4,2.088,3.21.8A.852.852,0,0,1,15.309,66.219ZM29.431,56.075a1.691,1.691,0,0,1-.859,1l-2.478,1.239L24.5,60.176l-.017.019-.016.017-.012.013-3.919,3.919a1.714,1.714,0,0,1-1.209.5,1.689,1.689,0,0,1-.41-.05l-6.172-1.543a1.693,1.693,0,0,1-.636-.311l-5.754-4.5L3.8,56.961a1.7,1.7,0,0,1-.748-2.313l2.619-5.016A1.712,1.712,0,0,1,7.945,48.9l2.383,1.191,5.183-1.511a1.706,1.706,0,0,1,1.179.083l3.514,1.59h1.745l2.479-1.24a1.712,1.712,0,0,1,2.272.735l2.619,5.015a1.691,1.691,0,0,1,.111,1.313Zm-6.884,3.649-3.371-2.451-.86.645a4.282,4.282,0,0,1-5.112,0l-.577-.433a1.7,1.7,0,0,1-.183-2.568l4.168-4.168a1.726,1.726,0,0,1,.2-.166l-.82-.371L10.8,51.726,7.9,57.281,13.161,61.4l6.172,1.543Zm1.99-2.212-2.9-5.558H17.818L13.65,56.122l.577.433a2.569,2.569,0,0,0,3.067,0l1.363-1.022a.852.852,0,0,1,1.012-.007l4.049,2.945Z",
    transform: "translate(-5.844 -46.819)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/Partner.00297cec3efa6f42149d112db513e26d.svg";
export { ForwardRef as ReactComponent };